<app-citizen-header></app-citizen-header>
<div class="w-full mx-auto bg-white">
  <div *ngIf="service$ | async as service"
       class="p-3 md:p-5 flex flex-col md:flex-row justify-start md:justify-between items-start w-11/12 mx-auto">
    <div class="w-full md:w-8/12 p-4">
      <div class="border-b border-primary-500">
        <app-portal-title-bar
          [title]="(service$ | async)?.serviceName">
        </app-portal-title-bar>
      </div>

      <p [style]="{ '--order': 3 / 8, opacity: 0 }" class="intro-x mt-2">
        {{ service?.serviceDescription }}
      </p>
      <h3
        [style]="{ '--order': 1 / 8, opacity: 0 }"
        class="text-primary-500 text-md py-2 intro-x"
        style="font-weight: bold">
        {{ "Mahitaji ya Kupata Huduma"|concat|translate }}
      </h3>

      <table [style]="{ '--order': 1 / 8, opacity: 0 }" class="w-full intro-x">
        <thead class="bg-primary-500 text-secondary-500">
        <tr style="height: 40px">
          <th class="col-md-1">
            <span class="mx-2 py-1">{{ "Hatua"|concat|translate }}</span>
          </th>
          <th class="col-md-6">
            <span class="mx-2 py-1">
              {{ "mahitaji ya kupata huduma"|concat|translate }}
            </span>
          </th>
          <th class="col-md-5">
            <span class="mx-2 py-1">
              {{ "Uhitaji"|concat|translate }}
            </span>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr
          *ngFor="let requirement of requirements$ | async; let i = index"
          [style]="{ '--order': i / 8, opacity: 0 }"
          class="intro-x bg-light_primary"
          style="height: 30px">
          <td class="border border-primary-500">
            <span class="mx-2">{{ i + 1 }}.</span>
          </td>
          <td class="border p-2 border-primary-500 flex flex-col">
            <span>{{ requirement?.requirement?.requirementName }}</span>
            <span class="text-xs text-gray-400">{{ requirement?.requirement?.descriptions }}</span>
            @if (requirement?.requirement?.modAlternativesRequirements?.length) {
              <span class="text-xs">
              <span class="text-primary-500">
                {{ 'Alternative Requirements' | concat | translate }}:
              </span>
                {{ requirement?.requirement?.modAlternativesRequirements }}
            </span>
            }
          </td>
          <td class="border p-2 border-primary-500">
              <span
                *ngIf="requirement?.requirementIsMandatory; else notNecessary"
                class="text-red-600"
              >{{ "mandatory" | translate }}</span
              >
            <ng-template #notNecessary
            ><span>{{ "not_mandatory" | translate }}</span></ng-template>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="grid md:grid-cols-3 grid-cols-1 gap-2 mt-3 justify-between">
        <div
          [style]="{ '--order': 1 / 8, opacity: 0 }"
          class="w-full intro-x col-span-1">
          <div class="text-primary-500 text-md py-2">
            <div class="py-1">{{ "Wanafaika wahuduma"|concat|translate }}</div>
            <div class="w-6/12 h-[2px] mt-1 mb-2 bg-secondary-500"></div>
          </div>
          <div *ngFor="let group of service?.serviceGroups; let i = index">
            <span class="font-semibold">{{ i + 1 }}.</span>
            <span *ngIf="group?.groupType == 'G2G'" class="mx-2">{{
                "government" | translate
              }}</span>
            <span *ngIf="group?.groupType == 'G2C'" class="mx-2">{{
                "citizen" | translate
              }}</span>
            <span *ngIf="group?.groupType == 'G2B'" class="mx-2">{{
                "business" | translate
              }}</span>
            <span *ngIf="group?.groupType == 'G2E'" class="mx-2">{{
                "employee" | translate
              }}</span>
            <span *ngIf="group?.groupType == 'G2F'" class="mx-2">{{
                "foreigner" | translate
              }}</span>
          </div>
        </div>
        <div
          [style]="{ '--order': 1 / 8, opacity: 0 }"
          class="w-full  intro-x col-span-1">
          <div class="text-primary-500 text-md py-2">
            <div class="py-1">{{ "Njia za kupata huduma kwa kupitia mtandao"|concat|translate }}</div>
            <div class="w-6/12 h-[2px] mt-1 mb-2 bg-secondary-500"></div>
          </div>
          <div *ngFor="let automation of servicesAutomations$ | async">
            <div *ngIf="automation.serviceIsAutomated">
              <div
                *ngFor="
                  let provision of automation?.serviceProvisions;
                  let i = index
                ">
                <div
                  *ngIf="provision?.serviceProvisionMeans === 'Web'"
                  class="p-2 px-3 mb-3 flex flex-col bg-white shadow-sm rounded-2xl"
                >
                  <p class="text-primary-500" style="font-weight: bold">
                    {{ "Mfumo wa Tovuti"|concat|translate }}
                  </p>
                  <p>{{ provision?.serviceSystemName }}</p>
                  <a [href]="provision?.serviceReachLink" target="_blank">{{ provision?.serviceReachLink }}</a>
                </div>
                <div
                  *ngIf="provision?.serviceProvisionMeans == 'MobileApp'"
                  class="p-2 mb-3 flex flex-col bg-white shadow-sm rounded-2xl"
                >
                  <p class="text-primary-500" style="font-weight: bold">
                    {{ "Aplikesheni ya Simu"|concat|translate }}
                  </p>
                  <p>{{ provision?.serviceSystemName }}</p>
                  <a [href]="provision?.serviceReachLink" target="_blank">{{ provision?.serviceReachLink }}</a>
                </div>
                <div
                  *ngIf="provision?.serviceProvisionMeans == 'USSD'"
                  class="p-2 mb-3 flex flex-col bg-white shadow-sm rounded-2xl"
                >
                  <p class="text-primary-500" style="font-weight: bold">
                    {{ "mSIMBO"|concat|translate }}
                  </p>
                  <p>{{ provision?.serviceSystemName }}</p>
                  <p>{{ provision?.serviceReachLink }}</p>
                </div>
                <div
                  *ngIf="provision?.serviceProvisionMeans == 'SMS'"
                  class="p-2 mb-3 flex flex-col bg-white shadow-sm rounded-2xl"
                >
                  <p class="text-primary-500" style="font-weight: bold">
                    {{ "Jumbe fupi"|concat|translate }}
                  </p>
                  <p>{{ provision?.serviceSystemName }}</p>
                  <p>{{ provision?.serviceReachLink }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-1">
          <div class="text-primary-500 text-md py-2">
            <div class="py-1">{{ "Pakupokea majibu ya huduma"|concat|translate }}</div>
            <div class="w-6/12 h-[2px] mt-1 mb-2 bg-secondary-500"></div>
          </div>
          <div
            class="text-sm"
            *ngFor="let channel of deliveryChannels$ | async; let i = index"
          >
            <div *ngIf="channel?.channelName == 'PHYSICAL_DELIVERY'">
              <span>{{ "Majibu ya huduma yatatolewa kwa njia ya Kuletewa ulipo"|concat|translate }}</span>
            </div>
            <div *ngIf="channel?.channelName == 'WALK_IN'">
              <span>{{ "Majibu ya huduma yatatolewa kwa njia ya Ofsini"|concat|translate }}</span>
            </div>
            <div *ngIf="channel?.channelName == 'ONLINE'">
              <span>{{ "Majibu ya huduma yatatolewa kwa njia ya Online"|concat|translate }}</span>
            </div>
          </div>
        </div>

      </div>
      <div>
        <div class="container-fluid">
          <div class="row mt-3">
            <div class="d-flex justify-content-end flex-wrap">
              <ng-container *ngFor="let status of allStatus; let i = index">
                <button
                  (click)="tabController(i)"
                  [class.bg-primary-500]="currentTabIndex === i"
                  class="px-2 py-2 m-1 border border-primary-500 transition-all duration-200 ease-linear hover:text-white hover:bg-primary-500 intro-x rounded-md flex justify-start items-center text-primary-500 "
                  color="default"
                  style="--order: {{ i / 2 + 1 }}"
                >
                  <mat-icon
                    [svgIcon]="status.icon"
                    class="mr-2 text-secondary-500"
                    style="height: 24px; width: 24px"
                  ></mat-icon>

                  <span
                    [class.text-white]="i === currentTabIndex"
                    class="px-2">{{ status.name |concat|translate }}</span>
                </button>
              </ng-container>
            </div>
          </div>

          <div class="w-full mt-3">
            <div *ngIf="currentTabIndex === 0">
              <div>
                <div class="bg-light_primary shadow-md rounded-md">
                  <div
                    *ngIf="(billings$ | async).length !== 0; else noBillingInfo"
                  >
                    <div
                      *ngFor="let billing of billings$ | async; let i = index"
                      class="p-3"
                    >
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <!-- BEGIN: Basic billing Details -->
                        <div class="d-flex flex-column move-up">
                          <div class="text-bold text-primary-500">
                            {{ "Aina ya mfumo wa malipo"|concat|translate }}
                          </div>
                          <div
                            class="text-bold text-muted my-2 lbb-dotted pb-1"
                          >
                            <span
                              *ngIf="billing?.billingScheme == 'FORMULAR_BASED'"
                            >{{ "formula_based" | translate }}</span
                            >
                            <span
                              *ngIf="billing?.billingScheme == 'CATALOGY_BASED'"
                            >{{ "catalog_based" | translate }}</span
                            >
                            <span
                              *ngIf="
                                billing?.billingScheme == 'PERCENTAGE_BASED'
                              "
                            >{{ "percentage_based" | translate }}</span
                            >
                            <span
                              *ngIf="billing?.billingScheme == 'DIRECT_COST'"
                            >{{ "direct_cost" | translate }}</span
                            >
                            <span *ngIf="billing?.billingScheme == 'NO_COST'">{{
                                "no_cost" | translate
                              }}</span>
                          </div>
                        </div>

                        <div *ngIf="billing?.billingCurrencies?.currencyCode" class="d-flex flex-column move-up">
                          <div class="text-bold text-primary-500">
                            {{ "sarafu"|concat|translate }}
                          </div>
                          <div
                            class="text-bold text-muted my-2 lbb-dotted pb-1"
                          >
                            {{ billing?.billingCurrencies?.currencyCode }}
                          </div>
                        </div>

                        <div
                          *ngIf="billing?.billingHasVariation && billing?.billingVariationReasons"
                          class="d-flex flex-column move-up"
                        >
                          <div class="text-bold text-primary-500">
                            {{ "billing_variation_reasons" | translate }}
                          </div>
                          <div
                            class="text-bold text-muted my-2 lbb-dotted pb-1"
                          >
                            {{ billing?.billingVariationReasons }}
                          </div>
                        </div>
                        <!-- END: Basic billing Details -->

                        <!-- BEGIN: lOAD More Button -->
                        <div class="flex justify-end items-center">
                          <button
                            (click)="loadmore(billing)"
                            class="bg-primary-500 px-3 py-2 hover:bg-[#FFC436] text-white rounded-md flex justify-start items-center"
                          >
                            <mat-icon
                              class="mr-2"
                              style="height: 20px; width: 20px"
                              svgIcon="loader"
                            ></mat-icon
                            >
                            <span>{{ "load_more" | translate }}</span>
                          </button>
                        </div>

                        <!-- END: lOAD More Button -->
                      </div>
                      <div>
                        <!-- ############################ -->
                        <!-- BEGIN: BILLING SCHEMES ARENA -->
                        <!-- ############################ -->

                        <!-- BEGIN: Formula based scheme -->
                        <div
                          *ngFor="
                            let scheme of formularScheme$ | async;
                            let i = index
                          "
                          class="row p-3"
                        >
                          <div class="col-md-12 d-flex flex-column move-up">
                            <div>
                              <div class="col-12 my-3">
                                <div>
                                  <h3
                                    class="text-primary-500"
                                    style="font-weight: 600"
                                  >
                                    {{ "payable_items" | translate }}
                                  </h3>
                                </div>
                                <!-- BEGIN: Payable items table -->
                                <table
                                  class="border-collapse border border-primary-500 w-full"
                                >
                                  <thead class="bg-primary-500 text-white">
                                  <tr
                                    class="bg-gray-200"
                                    style="height: 30px"
                                  >
                                    <th class="p-2">SN</th>
                                    <th class="p-2">
                                      {{ "item_name" | translate }}
                                    </th>
                                    <th class="p-2">
                                      {{ "item_base_cost" | translate }}
                                    </th>
                                    <th class="p-2">
                                      {{ "item_minimum_count" | translate }}
                                    </th>
                                    <th class="p-2">
                                      {{
                                        "item_incremental_value" | translate
                                      }}
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr
                                    *ngFor="
                                        let item of scheme?.formularPayableItems;
                                        let i = index
                                      "
                                    style="height: 50px"
                                  >
                                    <td class="border border-primary-500">
                                      <span class="mx-2">{{ i + 1 }}.</span>
                                    </td>
                                    <td class="border border-primary-500">
                                        <span class="mx-2">{{
                                            item?.itemName
                                          }}</span>
                                    </td>
                                    <td class="border border-primary-500">
                                      <span>{{ item?.itemBaseCost.toLocaleString() }}</span>
                                    </td>
                                    <td class="border border-primary-500">
                                        <span>{{
                                            item?.itemMinimumCount
                                          }}</span>
                                    </td>
                                    <td class="border border-primary-500">
                                        <span>{{
                                            item?.itemIncrimentalValue
                                          }}</span>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <!-- BEGIN: Payable items table -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- END: Formula based scheme --->

                        <!-- BEGIN: catalog based scheme -->
                        <div
                          *ngFor="
                            let scheme of catalogScheme$ | async;
                            let i = index
                          "
                          class="row p-3"
                        >
                          <div
                            *ngIf="scheme?.billingCatalogyItems?.length != 0"
                            class="col-md-12 d-flex flex-column move-up"
                          >
                            <div>
                              <div class="col-12 my-3">
                                <div>
                                  <h3
                                    class="text-primary-500"
                                    style="font-weight: 600"
                                  >
                                    {{ "payable_items" | translate }}
                                  </h3>
                                </div>
                                <!-- BEGIN: Payable items table -->
                                <table
                                  class="border-collapse border border-primary-500 w-full"
                                >
                                  <thead class="bg-primary-500 text-white">
                                  <tr style="height: 30px">
                                    <th>
                                      <span class="mx-2">{{ "SN"|concat|translate }}</span>
                                    </th>
                                    <th>
                                        <span class="mx-2">{{
                                            "item_name" | translate
                                          }}</span>
                                    </th>
                                    <th>
                                        <span class="mx-2">{{
                                            "item_unit_price" | translate
                                          }}</span>
                                    </th>
                                    <th>
                                        <span class="mx-2">{{
                                            "item_bulk_price" | translate
                                          }}</span>
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr
                                    *ngFor="
                                        let item of scheme?.billingCatalogyItems;
                                        let i = index
                                      "
                                    style="height: 30px"
                                  >
                                    <td
                                      [style]="{
                                          '--order': i / 3,
                                          opacity: 0
                                        }"
                                      class="border border-primary-500 intro-x"
                                    >
                                      <span class="mx-2">{{ i + 1 }}.</span>
                                    </td>
                                    <td
                                      [style]="{
                                          '--order': i / 3,
                                          opacity: 0
                                        }"
                                      class="border border-primary-500 intro-x"
                                    >
                                        <span class="mx-2">{{
                                            item?.itemName
                                          }}</span>
                                    </td>
                                    <td
                                      [style]="{
                                          '--order': i / 3,
                                          opacity: 0
                                        }"
                                      class="border border-primary-500 intro-x"
                                    >
                                        <span class="mx-2">{{
                                            item?.itemUnitPrice.toLocaleString()
                                          }}</span>
                                    </td>
                                    <td
                                      [style]="{
                                          '--order': i / 3,
                                          opacity: 0
                                        }"
                                      class="border border-primary-500 intro-x"
                                    >
                                        <span class="mx-2">{{
                                            item?.itemBulkPrice.toLocaleString()
                                          }}</span>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <!-- BEGIN: Payable items table -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- END: catalog based scheme ---->

                        <!-- BEGIN: percentage scheme -->
                        <div class="row p-3">
                          <div
                            *ngIf="
                              percentageScheme$ | async as percentageScheme
                            "
                            class="col-md-12 d-flex flex-column move-up"
                          >
                            <div *ngIf="percentageScheme.length != 0">
                              <div class="col-12 my-3">
                                <div>
                                  <h3
                                    class="text-primary-500"
                                    style="font-weight: 600"
                                  >
                                    {{ "payable_items" | translate }}
                                  </h3>
                                </div>
                                <!-- BEGIN: Payable items table -->
                                <table
                                  class="border-collapse border border-primary-500 w-full"
                                >
                                  <thead class="bg-primary-500 text-white">
                                  <tr style="height: 30px">
                                    <th>
                                      <span class="mx-2">{{ "SN"|concat|translate }}</span>
                                    </th>
                                    <th>
                                        <span class="mx-2">{{
                                            "item_name" | translate
                                          }}</span>
                                    </th>
                                    <th>
                                        <span class="mx-2">{{
                                            "billing_percentage" | translate
                                          }}</span>
                                    </th>
                                    <th>
                                        <span class="mx-2">{{
                                            "billing_description" | translate
                                          }}</span>
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr
                                    *ngFor="
                                        let scheme of percentageScheme$ | async;
                                        let i = index
                                      "
                                    style="height: 30px"
                                  >
                                    <td class="border border-primary-500">
                                      <span class="mx-2">{{ i + 1 }}.</span>
                                    </td>
                                    <td class="border border-primary-500">
                                        <span class="mx-2">{{
                                            scheme?.billingPercentage
                                          }}%</span>
                                    </td>
                                    <td class="border border-primary-500">
                                        <span class="mx-2">{{
                                            scheme?.billingPercentageDescription
                                          }}</span>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <!-- BEGIN: Payable items table -->
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- END: percentage scheme   -->

                        <!-- BEGIN: Direct cost -->
                        <div class="row p-3">
                          <div
                            *ngIf="
                              directCostScheme$ | async as directCostScheme
                            "
                            class="col-md-12 d-flex flex-column move-up"
                          >
                            <div *ngIf="directCostScheme.length != 0">
                              <div class="col-12 my-3">
                                <div>
                                  <h3
                                    class="text-primary-500"
                                    style="font-weight: 600"
                                  >
                                    {{ "payable_items" | translate }}
                                  </h3>
                                </div>

                                <!-- BEGIN: Payable items table -->
                                <table
                                  class="border-collapse border border-primary-500 w-full"
                                >
                                  <thead class="bg-primary-500 text-white">
                                  <tr style="height: 30px">
                                    <th>
                                      <span class="mx-2">{{ "SN"|concat|translate }}</span>
                                    </th>
                                    <th>
                                        <span class="mx-2"
                                        >{{ "billing_cost" | translate }} ({{
                                            billing?.billingCurrencies
                                              ?.currencyCode
                                          }})</span
                                        >
                                    </th>
                                    <th
                                      *ngIf="
                                          convertedValue &&
                                          convertedCurrency != ''
                                        "
                                    >
                                        <span class="mx-2"
                                        >{{
                                            "billing_cost" | translate
                                          }}
                                          (Tsh)</span
                                        >
                                    </th>
                                    <th>
                                        <span class="mx-2">{{
                                            "billing_description" | translate
                                          }}</span>
                                    </th>
                                  </tr>
                                  </thead>

                                  <tbody>
                                  <tr
                                    *ngFor="
                                        let scheme of directCostScheme$ | async;
                                        let i = index
                                      "
                                    style="height: 30px"
                                  >
                                    <td class="border border-primary-500">
                                      <span class="mx-2">{{ i + 1 }}.</span>
                                    </td>
                                    <td class="border border-primary-500">
                                        <span class="mx-2">{{
                                            scheme?.billingCost.toLocaleString()
                                          }}</span>
                                    </td>
                                    <td
                                      *ngIf="
                                          convertedValue &&
                                          convertedCurrency != ''
                                        "
                                      class="border border-primary-500"
                                    >
                                        <span
                                          *ngIf="
                                            convertedValue &&
                                              convertedCurrency != '';
                                            else notConverted
                                          "
                                          class="mx-2"
                                        >
                                          {{ convertedValue }}</span
                                        >
                                      <ng-template #notConverted>
                                        <span>-</span>
                                      </ng-template>
                                    </td>
                                    <td class="border border-slate-300">
                                        <span class="mx-2">{{
                                            scheme?.billingDescription
                                          }}</span>
                                    </td>
                                    <td
                                      *ngIf="!convertedValue"
                                      class="border border-slate-300 text-center"
                                    >
                                      <button
                                        (click)="
                                            exchangeCurrency(
                                              billing?.billingCurrencies
                                                ?.currencyCode,
                                              scheme?.billingCost
                                            )
                                          "
                                        class="add-button"
                                        mat-raised-button
                                      >
                                        <mat-icon
                                          svgIcon="dechange"
                                        ></mat-icon
                                        >
                                        {{ "convert" | translate }}
                                      </button>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- END: Direct cost ---->

                        <!-- ############################ -->
                        <!-- END: BILLING SCHEMES ARENA ---->
                        <!-- ############################ -->
                      </div>
                    </div>
                  </div>
                  <ng-template #noBillingInfo>
                    <div
                      class=" col-md-10 mt-4 mx-auto rounded-md p-4 text-center font-medium text-muted move-up"
                    >
                      {{ "billing_information" | translate }}
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>

            <div *ngIf="currentTabIndex === 1">
              <div class="bg-light_primary shadow-md rounded-md p-2 mb-2 ">
                <app-citizen-services-delivery-procedure-steps
                  [serviceUniqueId]="service?.serviceUniqueId"
                ></app-citizen-services-delivery-procedure-steps>
              </div>
            </div>

            <div *ngIf="currentTabIndex === 2">
              <div class="bg-light_primary p-3 shadow-md rounded-md mb-2">
                <app-request-forms [service]="service" [servicesAutomations]="servicesAutomations$ | async"></app-request-forms>
              </div>
            </div>

            <div *ngIf="currentTabIndex === 3">

              <app-feedback-window
                [serviceUniqueId]="service?.serviceUniqueId"
              ></app-feedback-window>


            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      [style]="{ '--order': 1 / 5, opacity: 0 }" class="w-full flex flex-col gap-3 md:w-4/12 p-4 intro-x">
      <div class="bg-light_primary  rounded-md">

        <div class="px-3 py-5  flex items-center gap-3" *ngIf="service?.serviceProvider as provider">
          <div class="p-2">
            @if (provider?.institutionLogo) {
              <img
                [src]="fileServer + provider?.institutionLogo"
                class="rounded"
                height="80"
                width="80"
              />
            } @else {
              <img src="/assets/images/emblem.png"
                   alt="Institution Logo"
                   class="h-10 lg:h-20 md:h-20 sm:h-14 cursor-pointer self-baseline"/>
            }

          </div>

          <div [style]="{ '--order': 1 / 8, opacity: 0 }" class="intro-x">
            <div class="text-primary-500  text-lg">
              {{ provider?.institutionName | titlecase }}
            </div>
            <div class="flex flex-col gap-1 mt-2">

              <p>
                <b class="mr-2"
                >{{ "Wizara"|concat|translate }}:</b
                >{{ provider?.institutionMinistry?.ministryName }}
              </p>
              <p>
                <b class="mr-2"
                >{{ "service_sectors" | translate }}:</b
                >{{ provider?.institutionSector?.sectorName }}
              </p>
              <p>
                <b class="mr-2">{{ "Anuani"|concat|translate }}:</b
                >{{ provider?.institutionEmail }}
              </p>

              <p>
                <b class="mr-2">{{ "Tovuti"|concat|translate }}:</b
                >{{ provider?.institutionWebsite }}
              </p>

              <div
                class="col-span-2 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-2 px-2">
                <span class="font-semibold text-md">{{ "Wasifu wa taasisi"|concat|translate }}</span>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div class="bg-light_primary px-5 py-4  flex gap-3 rounded-md">
        <div class="flex flex-col gap-2 flex-grow">
          <div class="text-gray-700 font-bold text-lg">
            {{ "Je Unahitaji msaada ?"|concat|translate }}
          </div>

          <div class="text-gray-700  text-md pb-1 ">
            {{ "Unaweza kutufikia kwa kupiga simu ama kutuma ujumbe mfupi kupitia "|concat|translate }}:
          </div>

          <div class="text-gray-700 border-b mt-2 text-lg border-secondary-400">
            {{ "Social Medias"|concat|translate }}
          </div>
          <div class="flex flex-wrap gap-3 mt-2">
            @for (x of socialMediaLinks; track x) {
              <div class="text-primary-400">
                <mat-icon [svgIcon]="x?.icon"></mat-icon>
              </div>
            }
            <div class="text-primary-400 flex">
          <span>
            govservicesportal
          </span>
              <mat-icon class="scale-50 align-top">north_east</mat-icon>
            </div>

          </div>
          <div class="grid grid-cols-2 mt-3 gap-1">
            <div
              class="col-span-1 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-1 px-2">
              <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="message"></mat-icon>
              <span class="font-semibold text-md">{{ "Tuma ujumbe"|concat|translate }}</span>
            </div>

            <div
              class="col-span-1 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-1 px-2">
              <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="phone-call"></mat-icon>
              <span class="font-semibold text-md">{{ "Piga simu"|concat|translate }}</span>
            </div>
            <div
              class="col-span-2 text-md flex items-center justify-center rounded-lg bg-primary-500/80 text-white py-1 px-2">
              <mat-icon class="text-secondary-500 align-middle scale-75" svgIcon="msaadaAi"></mat-icon>
              <span class="font-semibold text-md">{{ "Msaada Ai"|concat|translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <app-portal-footer></app-portal-footer>

</div>

